<template>
    <div>
        <!-- 招標案件編輯主畫面 -->
        <CCard class="w-100">
            <CCardHeader class="header_group">
                <strong>{{headerText}}</strong>
                <div>
                    <router-link class="btn btn-dark" to="" v-on:click.native.prevent="goBack">                    
                        {{$t('Buttons.GoBack')}}
                    </router-link>
                    <!-- add by [Issue 2022-07-28 ,#02] -->
                    <button type="button" class="btn btn-success" v-if="isShowViewAttachFiles" @click="viewAttachFiles">{{$t('Buttons.ViewAttachFiles')}}</button>
                </div>
            </CCardHeader>
            <CCardBody>
                <CNavbar light color="light">
                    <CForm>
                        <div class="CForminline">
                            <div :class="requiredCss('factory')">
                                <p>{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                <div v-for="(item, key) in factoryList" :key="'factory_input_' + key">
                                     <input type="radio" v-model="quoteRow.factoryId" :value="item.factoryId" :disabled="disableFactory(item)" >{{item.factoryCaption}} ({{item.factoryId}})
                                </div>
                            </div>
                            <div :class="requiredCss('date')">
                                <p>{{$t('QuoteInfo_Vue.StartDate')}}： {{ caseStartDate(quoteRow) }} </p>
                            </div>
                            <div :class="requiredCss('quotation_name')" v-if="isEdit">
                                <p>{{$t('QuoteInfo_Vue.QuoteNo')}}：</p>
                                <input type="text" maxlength="20" style="width:500px;" v-model="quoteRow.quoteNo" :disabled="isDisabled">
                            </div> 
                            <div :class="requiredCss('quotation_name')">
                                <p>{{$t('QuoteInfo_Vue.RequestName')}}：</p>
                                <input type="text" maxlength="200" style="width:500px;" v-model="quoteRow.requestName" :disabled="isDisabled" @blur="quoteNoBlurEvent">
                            </div>                            
                            <div :class="requiredCss('quotation_class')">
                                <p>{{$t('QuoteInfo_Vue.RequestType')}}：</p>

                                <div class="requestType-container">
                                    <div class="requestType" v-for="(item, key) in requestTypeList" :key="'requestType_input_' + key" >
                                        <input type="radio" name="requestType_input" :disabled="isDisabled" 
                                            v-model="quoteRow.requestType" 
                                            :value="item.requestTypeId" />{{item.requestTypeCaption}}
                                    </div>


                                    <div v-if="quoteRow.requestType === '21' || quoteRow.requestType === '22'">
                                        工務報價單號：
                                        <input type="text" v-model="quoteRow.workSystemQuoteNo" disabled>
                                    </div>
                                </div>
                            </div>
                            <div :class="requiredCss('quotation_method')">
                                <p>{{$t('QuoteInfo_Vue.RequestWay')}}：</p>
                                <div v-for="(item, key) in requestWayList" :key="'quotation_method_input_' + key" >
                                    <input type="radio" name="quotation_method_input" :disabled="isDisabled" 
                                        v-model="quoteRow.requestWay" 
                                        :value="item.requestWayId" />{{item.requestWayCaption}}
                                </div>
                            </div>
                            <div :class="requiredCss('audit')">
                                <p>{{$t('QuoteInfo_Vue.NotifySupervisor')}}：</p>
                                <div v-for="(item, key) in notifySupervisorList" :key="'audit_input_' + key" >
                                    <input type="radio" name="audit_input_" :disabled="isDisabled || disableNotifySupervisor" 
                                        v-model="quoteRow.notifySupervisor" 
                                        :value="item.notifySupervisorId" />{{item.notifySupervisorCaption}}
                                </div>
                            </div>
                            <div :class="requiredCss('engineering_money')" v-if="quoteRow.requestType === '21' || (quoteRow.requestType === '22' && quoteRow.factoryId !== 'GZ')">
                                <p v-if="quoteRow.requestType === '21'" >{{$t('QuoteInfo_Vue.Type_11Amount')}}：</p>
                                <p v-if="quoteRow.requestType === '22'" >{{$t('QuoteInfo_Vue.Type_12Amount')}}：</p>
                                <div v-if="quoteRow.factoryId === 'KH' || quoteRow.factoryId === 'KW' ">                                    
                                    <!-- 工程 -->
                                    <div v-if="quoteRow.requestType === '21'" >
                                        <span class="mr-4">KH</span>
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="KHMAX" :disabled="isDisabled" > 總價承攬超大型工程
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="KH501" :disabled="isDisabled" > TWD 500萬以上
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="KH500" :disabled="isDisabled" > TWD 500萬 ~ 5萬
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="KH005" :disabled="isDisabled" > TWD 5萬以下  
                                    </div>
                                    <!-- 弱電工程 -->
                                    <div v-if="quoteRow.requestType === '22'" >
                                        <span class="mr-4">KH</span>
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="KHMAX" :disabled="isDisabled" > 總價承攬超大型工程
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="KH501" :disabled="isDisabled" > TWD 500萬以上
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="KH500" :disabled="isDisabled" > TWD 500萬 ~ 5萬
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="KH005" :disabled="isDisabled" > TWD 5萬以下  
                                    </div>
                                </div>                                
                                <div v-else-if="quoteRow.factoryId === 'SZ' || quoteRow.factoryId === 'NJ' || quoteRow.factoryId === 'GZ'">                                    
                                    <!-- 工程 -->
                                    <div v-if="quoteRow.requestType === '21'">
                                        <span class="mr-4">大陸</span>
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="OTMAX" :disabled="isDisabled" > 總價承攬超大型工程
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="OT101" :disabled="isDisabled" > CNY 100萬以上
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="OT100" :disabled="isDisabled" > CNY 100萬 ~ 1,500元
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="OT001" :disabled="isDisabled" > CNY 1,500元以下
                                    </div>
                                    <!-- 弱電工程 -->
                                    <div v-if="quoteRow.requestType === '22' && quoteRow.factoryId !== 'GZ'">
                                        <span class="mr-4">大陸</span>
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="OTMAX" :disabled="isDisabled" > 總價承攬超大型工程
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="OT101" :disabled="isDisabled" > CNY 100萬以上
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="OT100" :disabled="isDisabled" > CNY 100萬 ~ 1,500元
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="OT001" :disabled="isDisabled" > CNY 1,500元以下
                                    </div>
                                </div>
                                <div v-else>                                    
                                    <!-- 工程 -->
                                    <div v-if="quoteRow.requestType === '21'">
                                        <span class="mr-4">越南</span>
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="VHMAX" :disabled="isDisabled" > 總價承攬超大型工程
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="VH101" :disabled="isDisabled" > VAN 34.9億以上
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="VH100" :disabled="isDisabled" > VAN 34.9億 ~ 524萬元
                                        <input type="radio" v-model="quoteRow.projectAmountType" value="VH001" :disabled="isDisabled" > VAN 524萬元以下
                                    </div>
                                    <!-- 弱電工程 -->
                                    <div v-if="quoteRow.requestType === '22'">
                                        <span class="mr-4">越南</span>
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="VHMAX" :disabled="isDisabled" > 總價承攬超大型工程
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="VH101" :disabled="isDisabled" > VAN 34.9億以上
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="VH100" :disabled="isDisabled" > VAN 34.9億 ~ 524萬元
                                        <input type="radio" v-model="quoteRow.lightAmountType" value="VH001" :disabled="isDisabled" > VAN 524萬元以下
                                    </div>
                                </div>                                    
                            </div>
                            <div :class="requiredCss('lightCurrentEngineering_money')" v-if="quoteRow.requestType === '22' && quoteRow.factoryId === 'GZ'">
                                <p>{{$t('QuoteInfo_Vue.Type_12Amount')}}：</p>
                                <span>大陸</span>
                                <!-- 弱電工程 -->
                                <input type="radio" v-model="quoteRow.lightAmountType" name="" value="OTMAX" :disabled="isDisabled" > 總價承攬超大型工程
                                <input type="radio" v-model="quoteRow.lightAmountType" name="" value="GZ101" :disabled="isDisabled" > CNY 100萬以上
                                <input type="radio" v-model="quoteRow.lightAmountType" name="" value="GZ100" :disabled="isDisabled" > CNY 100萬 ~ 1萬
                                <input type="radio" v-model="quoteRow.lightAmountType" name="" value="GZ001" :disabled="isDisabled" > CNY 1萬以下
                            </div> 
                            <div class="purchase_info requiredCss">
                                <p>{{$t('QuoteInfo_Vue.Deadline')}}：</p> <date-picker :lang="lang" v-model="quoteRow.deadline" format="YYYY-MM-DD" valueType="format" :disabled="isDisabled && quoteRow.caseClosed === 'Y' || timeUp" :disabled-date="deadlineDatePick" ></date-picker>
                                <p class="specialist">{{$t('QuoteInfo_Vue.Purchaser')}}： {{ casePurchaserName(quoteRow.purchaserName) }}</p>
                                <p v-if="isCaseClosed(quoteRow.caseClosed)">{{caseCloseText(quoteRow)}}</p>
                            </div>
                        </div>
                    </CForm>
                </CNavbar>
            </CCardBody>
        </CCard>

        <CCard>
            <CCardBody>
                <div class="text-right mb-2">
                    <button type="button" class="btn btn-success" 
                            v-on:click="showAddVendorModal"
                            v-if="!isContentOnlyView"
                            data-toggle="modal" data-target="#addVendorModal-M" 
                            :disabled="timeUp" >{{$t('Buttons.AddNew')}}</button>
                </div>
                <!-- Modal -->
                <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                刪除此廠商
                            </div>
                            <div class="modal-body">
                                <div class="alert-box">
                                    <div class="alert-icon">!</div>
                                    是否刪除此項目
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="deletePerson(deleteIndex)">{{i18n('Buttons.Delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <table class="table">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center" v-for="header in tableHeader" :key="header">{{ header }}</th>
                            <th class="text-center">{{i18n("PurchaseInfoTableHeader.Function")}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(vendor, index) in quoteRow.vendorList" :key="vendor.vendorId">
                            <td class="text-center">{{index + 1}}</td>
                            <td class="text-center">{{vendor.vendorId}}</td>
                            <td class="text-center">{{getVandorName(vendor)}}</td>
                            <td class="text-center">{{vendor.email}}</td>
                            <td class="text-center">{{fixDate(vendor.quotationDate)}}</td>
                            <td class="text-center">{{fixBoolTxt(vendor.quotation)}}</td>
                            <td class="text-center">{{vendor.currency}}</td>
                            <td class="text-right">{{getVendorVal(vendor.totalPriceWithoutTax)}}</td>
                            <td class="text-center">{{getVendorVal(vendor.memo)}}</td>
                            <td class="text-center">{{getVendorVal(fixBoolTxt(vendor.isLowestPrice))}}</td>
                            <td class="text-center">
                                <button type="button" class="btn btn-danger" @click="deleteModal(index)" :disabled="timeUp" v-if="!isContentOnlyView" >{{i18n('Buttons.Delete')}}</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
        <!-- 報價明細區塊 -->
        <PurchaseContent :quoteRow="quoteRow" :isEdit="isEdit" :isView="isContentOnlyView" :currentVendorId="'Radiant'" @getWorkSystemQuoteNo="getWorkSystemQuoteNo"/> 
        <!-- 新增廠商挑選區塊 -->
        <PersonSelect @updateVendors="updateVendors" :factoryId="quoteRow.factoryId" :vendorList="quoteRow.vendorList" :vendorType="'-M'"/>
        <div class="fixed-bottom" v-if="!isView">
            <button class="btn btn-info" @click="saveAll" :disabled="disableSave">
                {{$t('Buttons.SavedData')}}
            </button>
        </div>
        <!-- 查詢附件區塊 add by [Issue 2022-07-28 ,#02] -->
        <!-- Modal -->
        <div class="modal fade" id="viewAttachFilesModal" tabindex="-1" role="dialog" >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{$t('Buttons.ViewAttachFiles')}}
                    </div>
                    <div class="modal-body">
                        <table class="table">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center">項  目</th>
                                    <th class="text-center">檔案下載</th>                            
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in attachFilesList" :key="index">
                                    <td class="text-center">{{item.vendorName}}</td>
                                    <td class="text-center">
                                       <a v-if="hadAttachFile(item)" :href="getAttachFileUrl(item)" target="_blank">下載</a>
                                        <span v-else>無檔案</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-gray" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PurchaseContent from './PurchaseContent';
import PersonSelect from './PersonSelect'
import $ from 'jquery';
import { mapGetters } from 'vuex'
const getDafaultDeline = () =>{ //--截止日期預設日    
    let plusDay = 7;
    const weekDay = new Date().getDay();
    if(weekDay >=0 && weekDay < 4){ //日~三
        plusDay +=2;
    }else if(weekDay > 1 && weekDay < 6){ //四~五
        plusDay +=4;
    }else if(weekDay === 6){ //六
        plusDay +=3;     
    }
    var defaultDelineDate = new Date().addDays(plusDay);
    return defaultDelineDate.yyyymmdd();
};
export default {
    data() {
        return {
            isEdit: true,
            isDisabled: true,
            tableHeader: [ // 表格標題
                this.i18n('PurchaseInfoTableHeader.No'),
                this.i18n('PurchaseInfoTableHeader.QuotationVendorCode'),
                this.i18n('PurchaseInfoTableHeader.QuotationVendor'),
                this.i18n('PurchaseInfoTableHeader.E_mail'),
                this.i18n('PurchaseInfoTableHeader.QuotationDate'),
                this.i18n('PurchaseInfoTableHeader.Quotation'),
                this.i18n('PurchaseInfoTableHeader.Currency'),
                this.i18n('PurchaseInfoTableHeader.NetAmount'),
                this.i18n('PurchaseInfoTableHeader.Memo'),
                this.i18n('PurchaseInfoTableHeader.LowestPrice')
            ],
            guid: '',
            quoteRow: {vendorList: [] , requestType: '', factoryId: '' , projectAmountType: '',lightAmountType: '' ,deadline: '', workSystemQuoteNo: ''},
            timeUp: false,
            deleteIndex: '',
            quotation: false, //是否有任一廠商已經報價
            factoryList: this.$t('factoryListForPurchase'), //廠別 清單
            requestTypeList: this.$t('requestTypeList'), //報價類別 清單
            requestWayList: this.$t('requestWayList'), //報價方式 清單 
            notifySupervisorList: this.$t('notifySupervisorList'), //是否通知 清單
            caseClosedList: this.$t('caseClosedList'), //案件狀態 清單
            quoteRow_deadline: '',
            hadChangedVendorList : false,
            attachFilesList :[]
        }
    },
    props : {        
    },
    components: {
        PurchaseContent,
        PersonSelect,
    },
    computed :{
        ...mapGetters(['lang']),
        headerText (){
            if(this.isEdit){
                if(this.lang === 'en') {
                    return 'Edit Information';
                } else {
                    return '修改資訊';
                }
                
            }else{
                if(this.lang === 'en') {
                    return 'Add bidding';
                } else {
                    return '新增招標';
                }
                
            }            
        },
        disableNotifySupervisor (){
            const {requestType,projectAmountType ,lightAmountType } = this.quoteRow
            if('11' === requestType || '12' === requestType || '13' === requestType){ //當報價類別為[招標-五金文具/招標-廢品/招標-物流]時，預設為[是(Y)](無法修改)
                return true;
            }else if('30' === requestType ){
                return false;
            }else if('21' === requestType && ('KH501' === projectAmountType || 'OT101'  === projectAmountType) ){
                return true;
            }else if('22' === requestType && ('GZ101' === lightAmountType || 'OT101'  === lightAmountType  || 'KH501'  === lightAmountType)){
                return true;
            }
            return false;
        },        
        isView (){            
            const item = this.quoteRow;            
            if(item){
               if(!item.caseClosed && !item.deadline ){
                   return false;
               }
            }else{
                return true;
            }            
            const today= new Date().yyyymmdd();
            if(item.caseClosed === 'Y' || item.caseClosed === 'X'){
                return true;//案件已經關閉/作廢
            }
            if(item.deadline && item.deadline < today){
                return true;//報價截止日期<系統當日時，供應商不得於ROE平台上進行報價
            }          
            return false;
        },
        isClosed (){
            const item = this.quoteRow;
            if(item.caseClosed === 'Y' || item.caseClosed === 'X'){
                return true;//案件已經關閉/作廢
            }
            return false;
        },        
        isContentOnlyView (){
            if(this.isView){
                return true;
            }else {
                if(this.quoteRow && this.quoteRow.vendorList){
                    const list = this.quoteRow.vendorList;
                    let c = 0;
                    list.forEach(e=>{
                        if(e.quotation === true){
                            c+=1;
                        }
                    });
                    if(c > 0){
                        return true;
                    }
                }
            }
            return false;
        },
        isInvalidCase (){//是否為作廢案件 Fix by 議題[164]
            const item = this.quoteRow;            
            if(item){
               if(item.caseClosed === 'X'){
                   return true;
               }
            }
            return false;
        },
        isShowViewAttachFiles(){// add by [Issue 2022-07-28 ,#02] 查詢附件
            const item = this.quoteRow;            
            if(item){
               if(item.caseClosed === 'Y'){
                   return true;
               }
            }
            return false;
        },
        disableSave (){     //  當報價類別為[工程/弱電工程]，無"工務報價單號"的卡控
            const { requestType, workSystemQuoteNo } = this.quoteRow

            if(('21' === requestType || '22' === requestType) && !workSystemQuoteNo){
                return true;
            } else {
                return false;
            }

            return false;
        }, 
    },
    methods: {        
        getVendorVal(src){
            if(this.isClosed && !this.isInvalidCase){//Fix by 議題[164]
                return src;
            }
            return '';
        },
        getVandorName(item){
            if(item){
                if(item.vendorAbbreviation){
                    return item.vendorAbbreviation;
                }else if(item.vendorName){
                    return item.vendorName;
                }
            }
            return '';
        },
        goBack (){                        
            const self =this;
            if(self.isView){
                self.actionGoBack ();
                return;
            }            
            if(!self.isMember && !this.isContentOnlyView){
                if(self.isEdit){                    
                    const row = self.quoteRow;
                    if(!row.fileName && !row.addFiles){
                        this.$alert('無上傳附件檔案，不允許返回!','警告',{type: 'warning'});
                        return;
                    }
                }
            }
            this.$confirm('尚未儲存變更的資料，您確定要離開目前的網頁嗎？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                self.actionGoBack ();
            }).catch(() => {
                //console.log("放棄了");
            });
        },
        actionGoBack (){            
            if(!this.isView){
                const param = {guid : this.guid ,requestType : this.quoteRow.requestType };
                if(param.guid && param.requestType){//清除，可能上傳匯入的 Excel 資料
                    const url = `${this.$apiUrl_Quotation}/CancelQuoteData`;
                    this.axios.post(url, param).then(() => {
                    });
                }            
            }
            this.$router.push('/');
        },
        getDetail(guid) {//目前編輯的單筆採購案件
            const url = `${this.$apiUrl_Quotation}/GetRequestForQuote/${guid}`
            this.updateLoading(true)
            this.axios.get(url).then((response) => {
                console.log(response.data)
                let param = {
                    ...response.data,
                    startDate: response.data.startDate.substring(0,10),
                    deadline: response.data.deadline.substring(0,10),
                }

                this.quoteRow = param;
                //this.setUserFactoryId(); 編輯
                this.updateLoading(false)
            })
        },
        copyToNew(guid) {//複製單筆採購案件，並建立案件
            const url = `${this.$apiUrl_Quotation}/CopyQuoteToNew`
            const param = {guid : guid };
            this.updateLoading(true);
            this.quoteRow.requestType = '';
            this.axios.post(url, param).then((response) => {
                //console.log(response.data)
                let data = {
                    ...response.data,
                    startDate: response.data.startDate.substring(0,10),
                    deadline: response.data.deadline.substring(0,10),
                }                
                data.deadline = getDafaultDeline();//--設定截止日期預設日  
                this.quoteRow = data;
                this.guid = this.quoteRow.guid;
                this.setUserFactoryId();
                //this.guid = data.guid; 
                //this.quoteRow.guid= ''
                //this.guid = ''; //複製時，要當成新增
                this.updateLoading(false)
            })
        },
        updateVendors(selectedList) {            
            const purchaseId = this.guid;   
            let currency = 'TWD';
            const currentRow = this.quoteRow;
            if('SZ|NJ|GZ'.indexOf(currentRow.factoryId) > -1){
                currency = 'CNY';
            }            
            selectedList.map(item => {
                //補足其他欄位
                item.guid = '';
                item.quoteGuid = purchaseId;
                item.currency = currency;
                item.quotation =false;
                item.isLowestPrice =false;
                item.totalPriceWithoutTax= 0;
                currentRow.vendorList.push(item);
            })
            this.hadChangedVendorList = true;
        },
        deleteModal(index) { //刪除
            this.deleteIndex = index
            $('#deleteModal').modal('show')
        },
        deletePerson(index) {
            this.quoteRow.vendorList.splice(index, 1);
            this.hadChangedVendorList = true;
        },
        changeQuotation() {
            if(this.quoteRow && this.quoteRow.vendorList){
                this.quotation = this.quoteRow.vendorList.some(vendor => {
                    return vendor.quotation
                })
            }
        },
        checkQuoteParam (param){//檢核參數，都滿足則回傳 true
            const chkFileds = {
                factoryId : '廠別需選擇',
                requestName: '報價名稱需輸入',
                requestType: '報價類別需選擇',
                requestWay: '報價方式需選擇',
                notifySupervisor: '是否通知稽核主管需選擇',
                deadline: '截止報價日期需輸入'
            };
            for(let fd in chkFileds){
                let val = param[fd];
                if(val !== false && !val){//無此參數資料
                    this.$alert(chkFileds[fd],'警告',{type: 'warning'});
                    return false;
                }
            }
            if(!(param.vendorList && param.vendorList.length > 0)){
                this.$alert('必須要有報價廠商資料','警告',{type: 'warning'});
                return false;
            }
            return true;
        },
        saveAll() {
            let url = `${this.$apiUrl_Quotation}/UpdateRequestForQuote`;
            let param = { ...this.quoteRow };
            if(this.quotation && this.quoteRow.quoteNo && !this.hadChangedVendorList) {
                url = `${this.$apiUrl_Quotation}/UpdateDeadlineRequestForQuote`;
                param = {
                    guid: this.guid,
                    deadline: this.quoteRow.deadline
                };
            }else{
                //檢核參數
                if(!this.checkQuoteParam(param)){
                    return;
                }
            }
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--成功存檔
                    this.$router.push('/');
                }                
            });

        },
        showAddVendorModal () {            
            if(this.quoteRow && this.quoteRow.factoryId){
                return true;
            }else{
                this.$alert('請先挑選廠別','提示');
                //evt.d
                return false;
            }
        },
        disableWeekends (date) {
            const day = new Date(date).getDay()
            return day === 0 || day === 6
        },
        requiredCss (src){
            if(this.isEdit){
                return src;
            }else{
                return src + ' requiredCss';
            }
        },
        caseStartDate(quoteRow){ //開單日期
            if(this.isEdit){                
                return quoteRow.startDate;
            }else{
                let now = new Date();
                quoteRow.startDate = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
                return quoteRow.startDate;
            }
        },
        casePurchaserName (v){ //採購人員
            if(this.isEdit){
                return v;
            } else {                
                let userInfo = this.$userInfo ;
                if(userInfo && userInfo.accountName){
                    return userInfo.accountName;
                }
                return '';
            }
        },
        isCaseClosed (v){                        
            if(v && this.caseClosedList.findIndex(e => e.caseClosedId === v) > -1){
                return true;
            }
            if(v === 'X'){
                return true;
            }
            return false;
        },
        caseCloseText (row){                        
            if(row){
                const v = row.caseClosed;                
                let caseCloseTxt = this.fixZclose(v);
                if(row.settingCaseClosedUser){
                     caseCloseTxt = '指定結案(Y)[' + row.settingCaseClosedUserName + ']';
                }
                return `${this.i18n('SearchBar_Vue.CaseClosedText')}： ${caseCloseTxt}`;
            }
            return '';
        },
        setUserFactoryId(){
            if(!this.isEdit){
                const userFactoryId = this.$userInfo.userFactory; 
                this.quoteRow.factoryId = userFactoryId;
            }
        },
        deadlineDatePick (date){ //報價截止日，月曆日期挑選設定卡控
            let plusDay = 7;
            if(this.isEdit){
                plusDay = 9;
            }
            const weekDay = new Date().getDay();
            if(weekDay >=0 && weekDay < 2){ //日、一
                plusDay +=2;
            }else if(weekDay > 1 && weekDay < 6){ //二~五
                plusDay +=4;
            }else if(weekDay === 6){ //六
                plusDay +=3;     
            }            
            let maxDate;
            let minDate = new Date();
            const startDate = this.quoteRow.startDate;
            if(startDate && startDate.length === 10){
                const stDate =new Date(startDate + 'T00:00:00');
                let newMin = new Date(stDate.getTime()).addDays(1);
                maxDate = stDate.addDays(plusDay);                
                if(minDate > newMin){
                    minDate = newMin;
                }
            }else{
                maxDate = new Date().addDays(plusDay);                
            }
            return date < minDate || this.disableWeekends(date) || date > maxDate;
        },
        disableFactory (item){            
            if(this.isEdit) return true;
            if(this.isMember){
                return true;//供應商鎖定
            }else {
                const userFactory = this.$userInfo.userFactory;
                if(this.$isAdmin){    
                    return false;//管理者不鎖定
                } else {
                    if(item.factoryId === 'KW' || item.factoryId === userFactory){
                        return false;//採購人員，虛擬廠/本身不鎖定
                    }   
                    return true;     
                }
            }            
        },
        fixBoolTxt (v){
            if(v === true){
                return 'Y';
            }else if(v === false){
                return 'N';
            }
            return '';
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
        viewAttachFiles (){// add by [Issue 2022-07-28 ,#02] 查詢附件
            let purchaseId = this.quoteRow.guid; 
            const url = `${this.$apiUrl_Quotation}/ViewAttachFilesList/${purchaseId}`;
            const _self = this;
            _self.axios.get(url, {}).then((response) => {
                if(response.data){
                    _self.attachFilesList = response.data;
                    this.jqModalShow('viewAttachFilesModal');
                }else{
                    this.$alert('錯誤，查詢發生錯誤!','警告',{type: 'warning'});                    
                }
            });            
        },
        hadAttachFile(item){ //檢查判斷是否有供應商上傳的檔案
            if(item && item.addFiles && item.guid){
                return true;
            }
            return false;
        },
        getAttachFileUrl(item){ //取得下載路徑
            if(item  && item.addFiles && item.guid){
                let purchaseId = this.quoteRow.guid; 
                const url = `${this.$apiUrl_Quotation}/DownloadAttachFilesList/${purchaseId}/${item.guid}`;
                //const _self = this;
                return url;
            }
            return '#';
        },
        quoteNoBlurEvent (){// add by [Issue 2022-07-28 ,#03] 離開 [報價名稱] 此欄位時，觸發事件
           //卡控 [報價名稱]是否重覆
           //alert(this.quoteRow.requestName)
           const _self = this;
           const requestName = _self.quoteRow.requestName;
           if(!requestName) return;
           const url = `${this.$apiUrl_Quotation}/CheckRequestNameExist`;           
           const queryParam = { "guid": _self.quoteRow.guid , "requestName" : requestName};           
           _self.axios.post(url, queryParam).then((response) => {                        
                const respObj = response.data;                 
                if(respObj && respObj.startDate){
                    this.$alert("此空白標單已於 " + _self.fixDate(respObj.startDate) + " 上傳過，請確認是否重覆作業! 此為警告訊息，按 \"離開\"，可繼續往下作業",'警告',{type: 'warning' , confirmButtonText: '離開'});
                }
            })
        },
        getWorkSystemQuoteNo(quoteNo) {   //  回傳工務報價單號
            const _self = this;

            _self.quoteRow.workSystemQuoteNo = quoteNo;
        },
    },
    mounted() {
        const self =this;
        let purchaseId = sessionStorage.getItem('purchaseId');                
        if(purchaseId) {
            //編輯處理
            this.isEdit = true;
            this.isDisabled = true;
            this.getDetail(purchaseId);
        } else {            
            const q = this.$route.query;            
            if(q && q.purchaseId){
                //複製處理
                purchaseId =  q.purchaseId;
                this.copyToNew(purchaseId);
                this.isEdit = false;
                this.isDisabled = false;
            }else{
                //新增處理
                const url = `${this.$apiUrl_Quotation}/GetNewRequestForQuoteGuid`;
                const quoteRow = {vendorList: [] , requestType: '' ,factoryId: '', projectAmountType: '',lightAmountType: '', workSystemQuoteNo: ''};
                this.axios.get(url, {}).then((response) => {
                    if(response.data){
                        purchaseId = response.data;
                        quoteRow.guid= purchaseId;
                        self.setUserFactoryId();
                        //--設定截止日期預設日                        
                        quoteRow.deadline = getDafaultDeline();    
                        quoteRow.factoryId = self.$userInfo.userFactory;
                        self.quoteRow = quoteRow;
                    }else{
                        this.$alert('錯誤，無法新增!','警告',{type: 'warning'});
                        this.$router.push('/');
                    }
                });
                this.isEdit = false;
                this.isDisabled = false;
            }
        }        
        this.guid = purchaseId;
    },
    watch: {
        'quoteRow.requestType': function(v) {            
            if(v === '30'){ //報價類別其他，預設[非統一標單] requestWay=2
                this.quoteRow.requestWay='2';
            }else if('11' === v || '12' === v || '13' === v){
                this.quoteRow.notifySupervisor = true;
            }
        },
        'quoteRow.projectAmountType': function(v) {            
            if('KH501' === v || 'OT101'  === v ){
                this.quoteRow.notifySupervisor = true;
            }

            if('KHMAX' === v || 'OTMAX'  === v || 'VHMAX'  === v){
                this.quoteRow.notifySupervisor = true;
            }
        },
        'quoteRow.lightAmountType': function(v) {            
            if('GZ101' === v || 'OT101'  === v || 'KH501'  === v){
                this.quoteRow.notifySupervisor = true;
            }

            if('GZMAX' === v || 'OTMAX' === v || 'KHMAX'  === v || 'VHMAX'  === v){
                this.quoteRow.notifySupervisor = true;
            }
        },
        'quoteRow.deadline': function() {
            let now = new Date()
            let now_date = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
            if(Date.parse(now_date).valueOf() > Date.parse(this.quoteRow.deadline).valueOf()) {
                this.timeUp = true //disable
            } else {
                if(this.isView){
                    this.timeUp = true //disable
                }else{
                    this.timeUp = false
                }                
            }
            // console.log(this.timeUp)
        },
        'quoteRow.vendorList': {
            handler: function() {
                this.changeQuotation()
            },
            deep: true,
        },
        'lang': function() {
            this.tableHeader = [
                this.i18n('PurchaseInfoTableHeader.No'),
                this.i18n('PurchaseInfoTableHeader.QuotationVendorCode'),
                this.i18n('PurchaseInfoTableHeader.QuotationVendor'),
                this.i18n('PurchaseInfoTableHeader.E_mail'),
                this.i18n('PurchaseInfoTableHeader.QuotationDate'),
                this.i18n('PurchaseInfoTableHeader.Quotation'),
                this.i18n('PurchaseInfoTableHeader.Currency'),
                this.i18n('PurchaseInfoTableHeader.NetAmount'),
                this.i18n('PurchaseInfoTableHeader.Memo'),
                this.i18n('PurchaseInfoTableHeader.LowestPrice')
            ]

            this.factoryList = this.$t('factoryListForPurchase')  //廠別 清單
            this.requestTypeList = this.$t('requestTypeList') //報價類別 清單
            this.requestWayList = this.$t('requestWayList') //報價方式 清單 
            this.notifySupervisorList = this.$t('notifySupervisorList') //是否通知 清單
        }
    }    
}
</script>

<style lang="scss" scoped>
// @import '~bootstrap/scss/bootstrap.scss';
@import '@/assets/scss/select.scss';

.table tr:nth-child(even) {
    background-color: transparent;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}
.filter-btn-wrap {
    margin-top: 21px;
}
.option {
    margin-left: .2rem;
    cursor: pointer;
}
.item_list {
    margin-bottom: 5px;
}
.item-select #left-item .item-list .item, .item-select #right-item .item-list .item {
    display: flex;
    align-items: center;
}
.item-select #left-item .item-list .item input[type=checkbox], .item-select #right-item .item-list .item input[type=checkbox] {
    display: block;
    margin-right: .5rem;
}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.btn-secondary {
    background-color: gray;
}

.header_group {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.header_group button {
   margin-left: 8px;
}
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .factory, .date, .quotation_name, .factory_id, .quotation_class, .quotation_method, .audit, .purchase_info, .engineering_money, .lightCurrentEngineering_money {
        display: flex;
        align-items: center;
        margin: .5rem 0;

        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }

        > input {
            margin: 0 .5rem;
        }

        > span {
            margin: 0 .5rem;
        }

        > div {
             margin: 0 .5rem;
        }

    }

    > .purchase_info {
        > p:first-child {
            margin: 0;
        }
        > p {
            margin: 0 .5rem;
        }
    }
}

.factory_group, .class {
    > input[type=radio] {
        margin-left: 0.5rem;
    }
}

.fixed-bottom {
    left: auto;
    right: 80px;
    bottom: 10%;

    > .btn {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.requiredCss::before{
    content: "*";
    color: #f26161;
    font-weight: bolder;
    margin-bottom: 6px;
}



.requestType-container {
    display: flex;
    align-items: center;
    flex: 1;
    flex-wrap: wrap;

    .requestType {
        margin: 0 0.5rem;
        
        &:first-child {
            margin-left: 0;
        }

        &:nth-last-child(2) {
            margin-right: 24px;
        }
    }
}
</style>